var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.755 21.757h9.101c1.844 0 2.767-.911 2.767-2.767v-3.852H15.03v3.83c0 .782-.428 1.227-1.252 1.227H4.843c-.834 0-1.262-.445-1.262-1.227V6.25c0-.781.428-1.226 1.262-1.226h8.936c.824 0 1.252.445 1.252 1.226v3.83h1.592V6.229c0-1.845-.923-2.767-2.767-2.767h-9.1C2.91 3.46 2 4.383 2 6.228V18.99c0 1.856.911 2.767 2.755 2.767Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98 13.288h8.573l1.306-.065-.494.467-1.306 1.194a.644.644 0 0 0-.23.52c0 .402.285.706.68.706a.71.71 0 0 0 .516-.228l2.712-2.8c.197-.195.263-.369.263-.564 0-.196-.066-.37-.264-.565l-2.711-2.8a.672.672 0 0 0-.516-.227c-.395 0-.68.293-.68.694 0 .196.065.402.23.532l1.306 1.194.505.466-1.317-.065H9.979c-.406 0-.757.358-.757.77 0 .413.351.771.757.771Z",
    fill: "currentColor"
  })));
};
export default SvgLogout;